import { render } from "./FriendCard-NotLoggedIn.vue?vue&type=template&id=74d7703a&scoped=true"
import script from "./FriendCard-NotLoggedIn.vue?vue&type=script&lang=js"
export * from "./FriendCard-NotLoggedIn.vue?vue&type=script&lang=js"

import "./FriendCard-NotLoggedIn.vue?vue&type=style&index=0&id=74d7703a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d7703a"]])

export default __exports__